export const categories = [
  {
    id: 'xiangmu-gailan',
    name: '项目概览',
    slug: 'xiangmu-gailan',
    description: '了解 17c.com GitHub 项目的整体架构、核心功能与设计理念',
    icon: 'ri-folder-info-line',
    color: 'primary',
    articleCount: 5,
  },
  {
    id: 'shiyong-jiaocheng',
    name: '使用教程',
    slug: 'shiyong-jiaocheng',
    description: '从零基础到进阶的 17c.com GitHub 实战操作教程',
    icon: 'ri-book-open-line',
    color: 'accent',
    articleCount: 8,
  },
  {
    id: 'kaiyuan-ziyuan',
    name: '开源资源',
    slug: 'kaiyuan-ziyuan',
    description: '17c.com GitHub 上的开源代码库与相关资源合集',
    icon: 'ri-code-s-slash-line',
    color: 'secondary',
    articleCount: 6,
  },
  {
    id: 'daima-ku',
    name: '代码库',
    slug: 'daima-ku',
    description: '深入解析 17c.com GitHub 代码库结构与核心模块',
    icon: 'ri-git-repository-line',
    color: 'primary',
    articleCount: 4,
  },
  {
    id: 'changjian-wenti',
    name: '常见问题',
    slug: 'changjian-wenti',
    description: '17c.com GitHub 使用过程中的高频问题解答',
    icon: 'ri-question-answer-line',
    color: 'accent',
    articleCount: 7,
  },
  {
    id: 'gongju-tuijian',
    name: '工具推荐',
    slug: 'gongju-tuijian',
    description: '配合 17c.com GitHub 使用的优质开源工具推荐',
    icon: 'ri-tools-line',
    color: 'secondary',
    articleCount: 5,
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '17c.com GitHub 项目全面解析：从架构设计到核心功能',
    slug: '17c-github-xiangmu-quanmian-jiexi',
    categoryId: 'xiangmu-gailan',
    excerpt: '深入剖析 17c.com GitHub 项目的整体架构设计、技术选型与核心功能模块，帮助开发者快速理解项目全貌。',
    content: `
## 项目背景

17c.com 是一个综合性开发者资源平台，其在 GitHub 上托管的开源项目涵盖了从前端框架到后端服务、从工具库到完整解决方案的多个领域。本指南将从项目结构、核心模块、技术架构三个维度进行全面解析。

## 项目结构概览

17c.com GitHub 项目采用了 Monorepo 架构，主要包含以下核心目录：

- **packages/core** — 核心功能模块，包含数据处理、状态管理等基础能力
- **packages/ui** — UI 组件库，提供可复用的界面组件
- **packages/cli** — 命令行工具，支持项目脚手架和自动化脚本
- **packages/docs** — 文档站点源码
- **examples** — 示例项目集合

## 技术架构

项目采用现代化的技术栈：

1. **前端层** — 基于 React 19 + TypeScript 构建，使用 Vite 作为构建工具
2. **状态管理** — 采用轻量级状态管理方案
3. **样式方案** — 使用 TailwindCSS 实现原子化 CSS 样式
4. **测试体系** — Vitest + Testing Library 全覆盖测试
5. **CI/CD** — GitHub Actions 自动化构建与发布

## 核心功能模块

### 数据处理引擎

数据处理引擎是项目的核心，它支持多种数据源的接入与转换，提供了流式处理和批量处理两种模式。

### 组件化 UI 系统

UI 系统基于原子化设计理念，所有组件均支持主题定制、无障碍访问和响应式布局。

### CLI 工具链

CLI 工具提供了项目初始化、代码生成、构建优化等一系列命令，极大提升了开发效率。

## 快速上手

要开始使用 17c.com GitHub 上的项目，只需几个简单步骤即可完成环境搭建和项目启动。
`,
    tags: ['项目架构', '技术栈', '入门'],
    author: '17c 技术团队',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 'article-2',
    title: '17c.com GitHub 快速入门：环境搭建与第一个项目',
    slug: '17c-github-kuaisu-rumen',
    categoryId: 'shiyong-jiaocheng',
    excerpt: '手把手教你从零开始搭建 17c.com GitHub 开发环境，创建并运行你的第一个项目。',
    content: `
## 准备工作

在开始之前，请确保你的开发环境满足以下要求：

- Node.js 18.0 或更高版本
- Git 2.30 或更高版本
- 一个 GitHub 账号
- 基础的命令行操作能力

## 环境搭建步骤

### 第一步：克隆项目仓库

首先，你需要将 17c.com 的 GitHub 仓库克隆到本地：

\`\`\`bash
git clone https://github.com/17c/core-project.git
cd core-project
\`\`\`

### 第二步：安装依赖

使用包管理器安装项目依赖：

\`\`\`bash
npm install
# 或者使用 yarn
yarn install
# 或者使用 pnpm
pnpm install
\`\`\`

### 第三步：配置环境变量

复制环境变量模板文件并进行配置：

\`\`\`bash
cp .env.example .env.local
\`\`\`

### 第四步：启动开发服务器

\`\`\`bash
npm run dev
\`\`\`

## 创建你的第一个项目

### 使用 CLI 工具初始化

\`\`\`bash
npx 17c-cli create my-first-project
cd my-first-project
npm run dev
\`\`\`

## 常见问题排查

如果在环境搭建过程中遇到问题，请检查以下几点：

1. Node.js 版本是否符合要求
2. 网络连接是否正常
3. 依赖安装是否完整
`,
    tags: ['入门教程', '环境搭建', '新手'],
    author: '17c 技术团队',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    featured: true,
  },
  {
    id: 'article-3',
    title: '17c.com GitHub 开源资源大全：必备工具库与代码片段',
    slug: '17c-github-kaiyuan-ziyuan-da-quan',
    categoryId: 'kaiyuan-ziyuan',
    excerpt: '精选 17c.com GitHub 上最受欢迎的开源工具库、实用代码片段和项目模板合集。',
    content: `
## 开源资源分类

17c.com GitHub 上的开源资源涵盖了前端、后端、DevOps、数据科学等多个领域。本文为你整理了最受欢迎的几类资源。

## 前端工具库

### UI 组件库

提供了一套完整的 React 组件，包含表单、数据展示、导航、反馈等 50+ 常用组件。

### 工具函数集

包含 200+ 实用工具函数，涵盖日期处理、字符串操作、数组处理、类型检查等常见需求。

### Hooks 集合

整理了项目中最常用的自定义 Hooks，包括状态管理、数据请求、DOM 操作等场景。

## 后端资源

### API 中间件

提供了认证、日志、限流、缓存等常用中间件。

### 数据库工具

支持 PostgreSQL、MySQL、MongoDB 等多种数据库的连接池管理工具。

## DevOps 工具

### Docker 镜像

预配置的 Docker 镜像，支持一键部署。

### CI/CD 模板

GitHub Actions 和 GitLab CI 的工作流模板集合。

## 代码片段集合

项目 wiki 中收录了大量实用的代码片段，涵盖：

- 常见算法实现
- 设计模式示例
- 性能优化技巧
- 安全最佳实践
`,
    tags: ['开源资源', '工具库', '代码片段'],
    author: '17c 技术团队',
    publishDate: '2026-07-22',
    readTime: '10分钟',
    featured: true,
  },
  {
    id: 'article-4',
    title: '深入 17c.com GitHub 代码库：模块解析与贡献指南',
    slug: '17c-github-daima-ku-jiexi',
    categoryId: 'daima-ku',
    excerpt: '详细解读 17c.com GitHub 代码库的目录结构、核心模块设计及开源贡献流程。',
    content: `
## 代码库总览

17c.com GitHub 代码库采用模块化设计，每个模块职责清晰，便于维护和扩展。

## 核心模块详解

### @17c/core

核心模块是整个项目的基石，提供了以下能力：

- 事件系统：基于发布-订阅模式的事件总线
- 配置管理：支持多环境配置的动态加载
- 日志系统：分级日志输出与格式化
- 插件机制：可扩展的插件架构

### @17c/data

数据处理模块：

- 数据源适配器：统一的数据接入接口
- 数据转换管道：声明式的数据转换流程
- 缓存层：多级缓存策略

### @17c/api

API 模块：

- 请求拦截器链
- 响应处理器
- 错误处理中间件
- 请求重试与超时控制

## 贡献指南

### 提交规范

项目使用 Conventional Commits 规范：

- feat: 新功能
- fix: 修复 bug
- docs: 文档更新
- refactor: 代码重构
- test: 测试相关

### 代码审查流程

1. Fork 项目到个人仓库
2. 创建功能分支
3. 编写代码并通过测试
4. 提交 Pull Request
5. 等待代码审查

## 开发规范

项目代码严格遵循 ESLint + Prettier 规范，建议在编辑器中配置自动格式化。
`,
    tags: ['代码库', '模块解析', '贡献指南'],
    author: '17c 技术团队',
    publishDate: '2026-07-20',
    readTime: '12分钟',
    featured: false,
  },
  {
    id: 'article-5',
    title: '17c.com GitHub 常见问题 FAQ：从安装到部署',
    slug: '17c-github-changjian-wenti-faq',
    categoryId: 'changjian-wenti',
    excerpt: '收集整理了 17c.com GitHub 使用过程中最常被问到的 20 个问题及详细解答。',
    content: `
## 安装相关

### Q1: 安装依赖时报错怎么办？

首先检查 Node.js 版本是否满足要求（>=18.0），然后尝试清除缓存后重新安装。

### Q2: 支持哪些包管理器？

项目支持 npm、yarn 和 pnpm，推荐使用 pnpm 以获得更快的安装速度和更少的磁盘占用。

## 使用相关

### Q3: 如何自定义主题？

项目提供了主题配置文件，你可以通过修改 theme.config.ts 来定制颜色、字体、间距等样式变量。

### Q4: 如何接入第三方服务？

项目提供了插件机制，你可以通过编写插件来接入任何第三方服务。

## 部署相关

### Q5: 支持哪些部署方式？

- Vercel 一键部署
- Docker 容器化部署
- 传统服务器部署
- 静态站点托管

### Q6: 如何进行性能优化？

项目内置了多项性能优化策略，包括代码分割、懒加载、资源压缩、CDN 加速等。

## 安全相关

### Q7: 如何保证数据安全？

项目遵循 OWASP 安全最佳实践，支持 CSRF 防护、XSS 过滤、SQL 注入防护等。

## 更新与维护

### Q8: 如何升级到最新版本？

通过 CLI 工具可以一键检查并升级到最新版本，升级前会自动备份当前配置。
`,
    tags: ['FAQ', '问题解答', '故障排除'],
    author: '17c 技术团队',
    publishDate: '2026-07-18',
    readTime: '7分钟',
    featured: true,
  },
  {
    id: 'article-6',
    title: '配合 17c.com GitHub 的十大高效开源工具推荐',
    slug: '17c-github-gaoxiao-gongju-tuijian',
    categoryId: 'gongju-tuijian',
    excerpt: '精心挑选了 10 款与 17c.com GitHub 项目配合使用的高效开发工具，提升你的开发效率。',
    content: `
## 开发效率工具

### 1. VS Code 扩展包

我们为 VS Code 准备了一套完整的扩展包，包括代码片段、智能提示、格式化工具等。

### 2. Chrome DevTools 扩展

专为 17c.com 项目优化的 Chrome 开发者工具扩展，提供组件树查看、状态监控等功能。

### 3. Postman 集合

预配置的 API 测试集合，包含所有接口的请求模板和环境变量。

## 协作工具

### 4. Figma 设计套件

与项目 UI 组件库对应的 Figma 设计系统，包含所有组件的设计规范。

### 5. Storybook 组件文档

在线组件文档站点，支持组件预览、交互测试和文档生成。

## 自动化工具

### 6. GitHub Actions 工作流

预设的 CI/CD 工作流模板，支持自动化测试、构建和部署。

### 7. Renovate 依赖更新

自动化的依赖更新工具配置，保持项目依赖始终是最新版本。

## 监控与分析

### 8. Sentry 错误追踪

开箱即用的错误监控配置，支持实时错误通知和性能分析。

### 9. Lighthouse CI

自动化性能审计集成，确保每次提交都符合性能标准。

### 10. Bundle Analyzer

打包体积分析工具，帮助你优化构建产物的体积。
`,
    tags: ['工具推荐', '效率提升', '开发环境'],
    author: '17c 技术团队',
    publishDate: '2026-07-15',
    readTime: '9分钟',
    featured: false,
  },
  {
    id: 'article-7',
    title: '17c.com GitHub 项目版本管理策略与发布流程',
    slug: '17c-github-banben-guanli',
    categoryId: 'xiangmu-gailan',
    excerpt: '详解 17c.com GitHub 项目的语义化版本管理、变更日志维护和自动化发布流程。',
    content: `
## 语义化版本规范

17c.com GitHub 项目严格遵循语义化版本规范（SemVer）：

- **主版本号（MAJOR）**：不兼容的 API 修改
- **次版本号（MINOR）**：向下兼容的功能性新增
- **修订号（PATCH）**：向下兼容的问题修正

## 版本发布流程

### 发布前检查清单

1. 所有测试通过
2. 文档已更新
3. 变更日志已编写
4. 性能基准测试通过
5. 安全审计完成

### 自动化发布

我们使用 Changesets 来管理版本变更：

- 开发者提交变更说明
- CI 自动计算版本号
- 自动生成变更日志
- 自动发布到 npm

## Git 分支策略

采用 Trunk-Based Development 模式：

- main：主分支，始终保持可发布状态
- feature/*：功能分支，完成后合并到 main
- fix/*：修复分支，完成后合并到 main
- release/*：发布分支，用于发布准备

## 回滚策略

如果发现严重问题，可以通过 Git tag 快速回滚到上一个稳定版本。
`,
    tags: ['版本管理', '发布流程', 'Git'],
    author: '17c 技术团队',
    publishDate: '2026-07-12',
    readTime: '7分钟',
    featured: false,
  },
  {
    id: 'article-8',
    title: '17c.com GitHub 进阶教程：自定义插件开发实战',
    slug: '17c-github-zidingyi-chajian',
    categoryId: 'shiyong-jiaocheng',
    excerpt: '通过一个完整的实战案例，学习如何为 17c.com GitHub 项目开发自定义插件。',
    content: `
## 插件系统概述

17c.com GitHub 项目的插件系统基于依赖注入和生命周期钩子设计，允许开发者在不修改核心代码的情况下扩展功能。

## 插件开发基础

### 插件结构

一个标准的插件需要包含以下文件：

- plugin.json — 插件配置文件
- index.ts — 插件入口文件
- hooks/ — 生命周期钩子实现

### 生命周期钩子

- onInit：插件初始化时调用
- onMount：插件挂载时调用
- onUnmount：插件卸载时调用
- onConfigChange：配置变更时调用

## 实战案例：开发一个数据导出插件

### 第一步：创建插件项目

使用 CLI 工具快速创建插件脚手架

### 第二步：实现核心逻辑

编写数据导出功能，支持 CSV、JSON、Excel 三种格式

### 第三步：注册插件

将插件注册到项目的插件管理器中

### 第四步：测试与发布

编写单元测试，验证插件功能，然后发布到插件市场
`,
    tags: ['进阶教程', '插件开发', '实战'],
    author: '17c 技术团队',
    publishDate: '2026-07-10',
    readTime: '11分钟',
    featured: false,
  },
  {
    id: 'article-9',
    title: '17c.com GitHub 社区贡献者指南：从 PR 到成为维护者',
    slug: '17c-github-shequ-gongxian',
    categoryId: 'kaiyuan-ziyuan',
    excerpt: '详细指南教你如何参与 17c.com GitHub 开源社区，从提交第一个 PR 到成为核心维护者。',
    content: `
## 为什么参与开源贡献

参与 17c.com GitHub 开源社区不仅能提升你的技术能力，还能拓展人脉、积累项目经验。

## 贡献方式

### 代码贡献

- 修复 bug
- 实现新功能
- 优化性能
- 补充测试

### 非代码贡献

- 完善文档
- 翻译内容
- 设计改进
- 社区答疑

## 提交你的第一个 PR

### 准备工作

1. 阅读贡献指南
2. 熟悉代码规范
3. 加入社区讨论

### 寻找合适的 Issue

建议从 good first issue 标签开始，这些 Issue 通常比较简单，适合新手。

### PR 最佳实践

- 保持 PR 小而专注
- 提供清晰的描述
- 包含测试用例
- 及时响应审查意见

## 成为维护者

持续贡献高质量的代码、积极参与社区讨论、帮助其他贡献者，你将有机会被邀请成为项目维护者。
`,
    tags: ['社区贡献', 'PR', '开源参与'],
    author: '17c 技术团队',
    publishDate: '2026-07-08',
    readTime: '8分钟',
    featured: false,
  },
  {
    id: 'article-10',
    title: '17c.com GitHub 性能优化完全指南',
    slug: '17c-github-xingneng-youhua',
    categoryId: 'daima-ku',
    excerpt: '从构建优化到运行时性能，全方位解析 17c.com GitHub 项目的性能优化策略。',
    content: `
## 性能优化总览

性能优化贯穿于项目的整个生命周期，包括开发阶段、构建阶段和运行阶段。

## 构建优化

### 代码分割

利用动态导入实现按需加载，减小首屏包体积。

### Tree Shaking

通过 ES Module 的静态分析能力，移除未使用的代码。

### 资源压缩

启用 Gzip/Brotli 压缩，减小传输体积。

## 运行时优化

### 虚拟列表

对于大数据量列表，使用虚拟列表技术只渲染可视区域。

### 防抖与节流

对高频事件（滚动、输入等）进行防抖和节流处理。

### 缓存策略

利用 Service Worker 实现离线缓存和资源预加载。

## 网络优化

### CDN 加速

将静态资源部署到 CDN，利用边缘节点加速访问。

### 预加载与预连接

对关键资源使用 preload 和 preconnect 提示。

## 性能监控

项目内置了性能监控模块，支持 Core Web Vitals 指标的采集和上报。
`,
    tags: ['性能优化', '构建优化', '运行效率'],
    author: '17c 技术团队',
    publishDate: '2026-07-05',
    readTime: '10分钟',
    featured: false,
  },
  {
    id: 'article-11',
    title: '17c.com GitHub 安全最佳实践指南',
    slug: '17c-github-anquan-shijian',
    categoryId: 'changjian-wenti',
    excerpt: '全面介绍 17c.com GitHub 项目中的安全最佳实践，包括认证授权、数据保护与漏洞防范。',
    content: `
## 安全总览

安全是 17c.com GitHub 项目的核心关注点之一。我们遵循纵深防御原则，在多个层面保障项目安全。

## 认证与授权

### JWT Token 管理

- Token 有效期控制
- Refresh Token 轮换机制
- Token 黑名单策略

### RBAC 权限模型

基于角色的访问控制，支持细粒度的权限配置。

## 数据保护

### 敏感数据加密

所有敏感数据在存储和传输过程中均进行加密处理。

### 输入验证

对所有用户输入进行严格的类型校验和格式验证。

## 依赖安全

### 依赖审计

定期使用 npm audit 扫描依赖项中的已知漏洞。

### 供应链安全

使用签名验证确保依赖包的真实性。

## 部署安全

### 环境隔离

严格区分开发、测试和生产环境，杜绝配置泄露。

### 密钥管理

所有密钥和凭证通过环境变量注入，不写入代码。
`,
    tags: ['安全', '最佳实践', '数据保护'],
    author: '17c 技术团队',
    publishDate: '2026-07-02',
    readTime: '9分钟',
    featured: false,
  },
  {
    id: 'article-12',
    title: 'GitHub Actions 自动化工作流：17c.com 项目实战配置',
    slug: '17c-github-github-actions',
    categoryId: 'gongju-tuijian',
    excerpt: '从零配置 GitHub Actions 自动化工作流，实现 17c.com 项目的 CI/CD 全流程自动化。',
    content: `
## GitHub Actions 简介

GitHub Actions 是 GitHub 提供的 CI/CD 平台，可以自动化构建、测试和部署流程。

## 基础工作流配置

### 代码检查工作流

自动化运行 ESLint、TypeScript 类型检查和单元测试。

### 构建工作流

每次提交自动构建项目，确保代码可以正常编译。

### 发布工作流

打 tag 时自动发布 npm 包并更新文档站点。

## 高级配置

### 矩阵构建

使用矩阵策略同时测试多个 Node.js 版本和操作系统。

### 缓存优化

合理配置依赖缓存，减少工作流执行时间。

### 环境部署

自动部署到 staging 和 production 环境。

## 监控与通知

工作流执行结果通过 Slack 和邮件通知相关人员，确保问题及时发现和处理。
`,
    tags: ['GitHub Actions', 'CI/CD', '自动化'],
    author: '17c 技术团队',
    publishDate: '2026-06-28',
    readTime: '8分钟',
    featured: false,
  },
];

export const faqItems = [
  {
    question: '17c.com GitHub 项目需要什么基础才能上手？',
    answer: '建议具备基础的 JavaScript/TypeScript 编程能力，了解 Git 基本操作，熟悉命令行工具的使用。如果你是初学者，可以从我们的入门教程开始，逐步学习。',
  },
  {
    question: '17c.com GitHub 项目是否免费开源？',
    answer: '是的，17c.com GitHub 上的核心项目完全免费开源，采用 MIT 许可证。你可以自由使用、修改和分发。部分高级功能可能需要付费订阅。',
  },
  {
    question: '如何获取 17c.com GitHub 的最新资源更新？',
    answer: '你可以通过 Watch 项目仓库获取更新通知，也可以订阅我们的邮件列表或关注官方社交媒体账号获取最新动态。',
  },
  {
    question: '17c.com GitHub 项目支持哪些技术栈？',
    answer: '项目主要基于 React + TypeScript + Node.js 技术栈，同时支持与 Vue、Angular 等主流前端框架的互操作。',
  },
  {
    question: '在哪里可以找到 17c.com GitHub 的完整文档？',
    answer: '完整的项目文档托管在项目官网和 GitHub Wiki 中，包括 API 参考、使用指南、常见问题等。你也可以查看项目中的 docs 目录。',
  },
  {
    question: '如何在本地运行 17c.com GitHub 项目？',
    answer: '克隆仓库后执行 npm install 安装依赖，然后运行 npm run dev 启动开发服务器。详细步骤请参阅我们的快速入门教程。',
  },
];

export const testimonials = [
  {
    name: '张明',
    role: '全栈开发工程师',
    avatar: 'ZM',
    content: '17c.com GitHub 项目的文档非常详尽，让我在三天内就完成了项目集成。代码质量很高，值得信赖。',
  },
  {
    name: '李婷',
    role: '前端技术负责人',
    avatar: 'LT',
    content: '我们的团队一直在使用 17c.com GitHub 的工具库，极大地提升了开发效率。强烈推荐给所有开发者。',
  },
  {
    name: '王浩',
    role: '开源贡献者',
    avatar: 'WH',
    content: '作为 17c.com GitHub 项目的贡献者，我感受到社区的热情和专业。项目管理规范，贡献流程清晰。',
  },
  {
    name: '陈雪',
    role: 'DevOps 工程师',
    avatar: 'CX',
    content: '自动化部署工具链非常完善，帮助我们节省了大量的运维时间。GitHub Actions 模板直接开箱即用。',
  },
];